import React from 'react'
import { VscHistory } from "react-icons/vsc";
import { TbCashBanknoteFilled } from "react-icons/tb";
import { NavLink } from 'react-router-dom';



const wallet = () => {
  return (
    <div>

        <div className='container mt-5 pt-2'>
            <div className='row'>
                <div className='col-lg-12 col-sm-12 mt-4'>
                    
                  <NavLink  to="/transaction-history" style={{textDecoration:'none'}}>  <div className='card py-3' style={{backgroundColor:'#cde8f86b',border:'1px solid #cde8f8'}}>
                        <div className='card-body'>

                            <div className='row'>
                                <div className='col-3'>
                                  
                                  <div style={{display:'flex', justifyContent:'center'}}>
                            <VscHistory className=' fs-3'  style={{color:'#959595'}} />
                                </div>
                                </div>
                                <div className='col-6'> 
                                <p className='mb-0 '  style={{color:'#959595'}} >Order History</p>
                                </div>
                            </div>  
                        </div>
                    </div> </NavLink>
                </div>

             

            </div>

            <div className='row mt-5'>
                                <div className='col-lg-12'>
                                    <div className='card border-0'  style={{backgroundColor:'#4782f4', borderRadius:'15px'}}>
                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='col-6'>

                                                    <h6 className='text-white'> <TbCashBanknoteFilled className='text-white' style={{color:'green', fontSize:'17px'}}/> ₹0</h6>
                                                    <h6 className='text-white'>Deposit Cash </h6>
                                                </div>
                                                {/* <div className='col-2'></div> */}
                                                <div className='col-6  '>
                                                            <div  style={{display:'flex', justifyContent:'end'}}> 
                                                   <NavLink to="/addcase"  style={{textDecoration:'none'}}>  <button className='btn  '  style={{border:'1px solid #fff', color:'#fff'}}> ADD CASH</button> </NavLink>
                                                </div>
                                                </div>
                                            </div>
                                             <div className='my-4  '> 
                                            <p className='mb-0'  style={{color:'#dfb3ff'}}>Can be used to play Tournaments & Battles.</p>
                                             <p  style={{color:'#dfb3ff'}}> Cannot be withdrawn to Paytm or Bank.</p>
                                        </div>
                                        </div>
                                    </div>



                                    <div className='card border-0 mt-4'  style={{backgroundColor:'#4782f4', borderRadius:'15px'}}>
                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='col-6'>

                                                    <h6 className='text-white'> <TbCashBanknoteFilled className='text-white' style={{color:'green', fontSize:'17px'}}/> ₹0</h6>
                                                    <h6 className='text-white'>Winning Cash</h6>
                                                </div>
                                                {/* <div className='col-3'></div> */}
                                                <div className='col-6'>
                                                <div  style={{display:'flex', justifyContent:'end'}}> 
                                                    <button className='btn  '  style={{border:'1px solid #fff', color:'#fff'}}> Withdraw</button>
                                                </div>
                                                </div>
                                            </div>
                                             <div className='my-4  '> 
                                            <p className='mb-0'  style={{color:'#dfb3ff'}}>Can be withdrawn to Paytm or Bank. Can be used to play Tournaments & Battles.
                                            </p> 
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
        </div>
    </div>
  )
}

export default wallet